import * as yup from 'yup';

export const loginSchema = yup.object({
    hospital_email_id: yup.string().email().required(),
    password: yup.string().required(),
})